const CHOROPLETH_STYLES = {
	OPACITY: {
		DEFAULT: 0.5,
		HOVERED: 0.7,
		UNHOVERED: 0.5,
	},
};

export default CHOROPLETH_STYLES;
